import { z } from 'zod';
import { AddProfilePhotoInput, ProfilePhotoPage, ProfilePhotoView, ProfilePhotoQuery, } from '../../profile-photos.js';
import { EditProfileInput, ManageProfilesInput, ProfileLifecycleInput, ProfileUsername, IdListQuery, ProfileView, SaveSectionInput, UpdateAreasInput, UpdateProfileInput, UserSummary, } from '../../profile.js';
export const profileRoutes = {
    edit: {
        method: 'PATCH',
        path: '/me/profile/edit',
        body: EditProfileInput,
        response: ProfileView,
    },
    order: {
        method: 'PUT',
        path: '/me/profile/order',
        body: ManageProfilesInput,
        response: ProfileView,
    },
    lifecycle: {
        method: 'POST',
        path: '/me/profile/categories/:category1',
        body: ProfileLifecycleInput,
        response: ProfileView,
    },
    usernameAvailable: {
        method: 'GET',
        path: '/me/profile/username',
        query: z.object({ username: ProfileUsername }),
        response: z.object({ available: z.boolean() }),
    },
    photos: {
        method: 'GET',
        path: '/users/:userId/profile/photos',
        query: ProfilePhotoQuery,
        response: ProfilePhotoPage,
    },
    addPhoto: {
        method: 'POST',
        path: '/me/profile/photos',
        body: AddProfilePhotoInput,
        response: ProfilePhotoView,
    },
    deletePhoto: {
        method: 'DELETE',
        path: '/me/profile/photos/:photoId',
        response: z.object({ deleted: z.literal(true) }),
    },
    photoAvatar: {
        method: 'PUT',
        path: '/me/profile/photo-avatar',
        body: z.object({ photoId: z.string().min(1) }),
        response: ProfileView,
    },
    me: {
        method: 'GET',
        path: '/me/profile',
        response: ProfileView,
    },
    /** Edit an existing profile; first-time profile creation belongs to onboarding completion. */
    update: {
        method: 'PUT',
        path: '/me/profile',
        body: UpdateProfileInput,
        response: ProfileView,
    },
    /**
     * The category-selection checkboxes on an existing profile.
     *
     * Separate from `update` because that route is PUT-the-whole-profile: it
     * clears every optional field the payload omits, so a screen that knows only
     * about areas cannot use it without wiping the rest.
     */
    updateAreas: {
        method: 'PUT',
        path: '/me/profile/areas',
        body: UpdateAreasInput,
        response: ProfileView,
    },
    /**
     * One "Account Settings <Category>" screen's Save (FR-PROF-07).
     *
     * Independent and idempotent per category: a member fills the areas in one
     * at a time, in any order, or never — abandoning after the second screen
     * leaves a valid profile rather than a half-written one. Saving also selects
     * the area, so the two acts cannot drift apart.
     *
     * The body is validated twice: the envelope by the contract, then each field
     * against the registry's definitions for THIS category, which are runtime
     * data (FR-ADM-60).
     */
    saveSection: {
        method: 'PUT',
        path: '/me/profile/sections/:category1',
        body: SaveSectionInput,
        response: ProfileView,
    },
    /**
     * De-select an area. The answers are KEPT — re-selecting restores them,
     * which is what a member expects from a checkbox they unticked by accident.
     */
    deleteSection: {
        method: 'DELETE',
        path: '/me/profile/sections/:category1',
        response: ProfileView,
    },
    byUser: {
        method: 'GET',
        path: '/users/:userId/profile',
        response: ProfileView,
    },
    /**
     * Batched author lookup for cards and rows — one call per page instead of
     * one per item. Blocked-either-way members are omitted (AC-GL-18); unknown
     * ids are omitted, so callers key by id.
     */
    summaries: {
        method: 'GET',
        path: '/users/summaries',
        query: IdListQuery,
        response: z.array(UserSummary),
    },
};
//# sourceMappingURL=routes.js.map